import { Link } from "react-router-dom";
import { MapPin, Mail } from "lucide-react";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="mt-24 bg-[color:var(--brand-navy)] text-slate-100"
        >
            <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 lg:grid-cols-4 lg:px-8">
                <div>
                    <div className="mb-4 flex items-center gap-3">
                        <img
                            src="/brand/logo.png"
                            alt="Central Florida Mobility Rentals"
                            className="h-14 w-14 rounded-full bg-white object-contain p-1"
                        />
                        <div className="font-display text-lg font-extrabold tracking-tight text-white">
                            Central Florida Mobility Rentals
                        </div>
                    </div>
                    <p className="text-sm leading-relaxed text-slate-300">
                        Mobility scooter rentals delivered across Orlando,
                        Kissimmee &amp; Port Canaveral.
                        <span className="mt-2 block text-[color:var(--brand-gold)] font-medium">
                            Freedom Delivered.
                        </span>
                    </p>
                </div>

                <div>
                    <h4 className="mb-4 text-sm font-semibold uppercase tracking-wider text-slate-200">
                        Explore
                    </h4>
                    <ul className="space-y-2 text-sm">
                        <li>
                            <Link
                                data-testid="footer-scooters-link"
                                to="/scooters"
                                className="text-slate-300 hover:text-[color:var(--brand-green)]"
                            >
                                Rent a Scooter
                            </Link>
                        </li>
                        <li>
                            <Link
                                data-testid="footer-concierge-link"
                                to="/port-canaveral-cruise-scooter-rental"
                                className="text-slate-300 hover:text-[color:var(--brand-green)]"
                            >
                                Cruise Concierge
                            </Link>
                        </li>
                        <li>
                            <Link
                                data-testid="footer-delivery-link"
                                to="/delivery-area"
                                className="text-slate-300 hover:text-[color:var(--brand-green)]"
                            >
                                Delivery Area
                            </Link>
                        </li>
                        <li>
                            <Link
                                data-testid="footer-policies-link"
                                to="/rental-policies"
                                className="text-slate-300 hover:text-[color:var(--brand-green)]"
                            >
                                Rental Policies
                            </Link>
                        </li>
                        <li>
                            <Link
                                data-testid="footer-faq-link"
                                to="/faq"
                                className="text-slate-300 hover:text-[color:var(--brand-green)]"
                            >
                                FAQ
                            </Link>
                        </li>
                    </ul>
                </div>

                <div>
                    <h4 className="mb-4 text-sm font-semibold uppercase tracking-wider text-slate-200">
                        Contact
                    </h4>
                    <ul className="space-y-3 text-sm text-slate-300">
                        <li className="flex items-start gap-3">
                            <MapPin className="mt-0.5 h-4 w-4 text-[color:var(--brand-gold)]" />
                            <span>
                                924 N Magnolia Avenue, Suite 202
                                <br />
                                Orlando, FL 32803
                            </span>
                        </li>
                        <li className="flex items-center gap-3">
                            <Mail className="h-4 w-4 text-[color:var(--brand-gold)]" />
                            <a
                                data-testid="footer-email-link"
                                href="mailto:info@cflmobilityrentals.com"
                                className="hover:text-[color:var(--brand-green)]"
                            >
                                info@cflmobilityrentals.com
                            </a>
                        </li>
                    </ul>
                </div>

                <div>
                    <h4 className="mb-4 text-sm font-semibold uppercase tracking-wider text-slate-200">
                        Hours
                    </h4>
                    <ul className="space-y-1 text-sm text-slate-300">
                        <li>Mon – Sat: 8:00 AM – 8:00 PM</li>
                        <li>Sun: 9:00 AM – 6:00 PM</li>
                        <li className="pt-2 text-[color:var(--brand-gold)] font-medium">
                            Deliveries 7 days a week
                        </li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-white/10">
                <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-2 px-4 py-6 text-xs text-slate-400 sm:flex-row sm:items-center sm:px-6 lg:px-8">
                    <span>
                        © {new Date().getFullYear()} Central Florida Mobility
                        Rentals. All rights reserved.
                    </span>
                    <span>
                        Website by Central Florida Mobility Rentals •{" "}
                        <Link
                            to="/rental-policies"
                            className="hover:text-[color:var(--brand-green)]"
                        >
                            Terms
                        </Link>
                    </span>
                </div>
            </div>
        </footer>
    );
}
